/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface NewPasswordRequest
 */
export interface NewPasswordRequest {
  /**
   * Верификационный токен из ответа reset-password-token
   * @type {string}
   * @memberof NewPasswordRequest
   */
  token: string
  /**
   * Новый пароль (минимальная длина задаётся серверной настройкой)
   * @type {string}
   * @memberof NewPasswordRequest
   */
  password: string
  /**
   * Подтверждение пароля (должно совпадать с password)
   * @type {string}
   * @memberof NewPasswordRequest
   */
  passwordConfirmation: string
}

/**
 * Check if a given object implements the NewPasswordRequest interface.
 */
export function instanceOfNewPasswordRequest(
  value: object
): value is NewPasswordRequest {
  if (!('token' in value) || value['token'] === undefined) return false
  if (!('password' in value) || value['password'] === undefined) return false
  if (
    !('passwordConfirmation' in value) ||
    value['passwordConfirmation'] === undefined
  )
    return false
  return true
}

export function NewPasswordRequestFromJSON(json: any): NewPasswordRequest {
  return NewPasswordRequestFromJSONTyped(json, false)
}

export function NewPasswordRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): NewPasswordRequest {
  if (json == null) {
    return json
  }
  return {
    token: json['token'],
    password: json['password'],
    passwordConfirmation: json['passwordConfirmation'],
  }
}

export function NewPasswordRequestToJSON(
  value?: NewPasswordRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    token: value['token'],
    password: value['password'],
    passwordConfirmation: value['passwordConfirmation'],
  }
}
